import { useDispatch, useSelector } from 'react-redux'

import { Customer, FetchCustomerProps } from './model/customer.model'
import { fetchCustomer } from './store/customer.reducer'
import {
  selectCustomer,
  selectCustomerLoading,
  selectCustomerError,
} from './store/customer.selectors'

import { StoreError } from '~/common/model'

interface useCustomer {
  getCustomer: (fetchCustomerProps: FetchCustomerProps) => unknown
  customer?: Customer
  loading: boolean
  error?: StoreError
}

export default function useCustomer(): useCustomer {
  const dispatch = useDispatch()

  return {
    getCustomer: (fetchCustomerProps: FetchCustomerProps) =>
      dispatch(fetchCustomer(fetchCustomerProps)),
    customer: useSelector(selectCustomer),
    loading: useSelector(selectCustomerLoading),
    error: useSelector(selectCustomerError),
  }
}
